module.exports = __webpack_public_path__ + "img/favicon.e78105c1.png";